// Reducer
import * as CalendarReducer from './calendar.reducers';


// Set true/false if the current time is within work hours/days ====================================================================================================

export const setIsWithinWorkHours = (data) => async (dispatch) => {
  dispatch(CalendarReducer.setIsWithinWorkHours(data));
}